module.exports = "img/pmc.e5e521.jpg";